module.exports = __webpack_public_path__ + "img/Res_Mus_8kl.9938c3c2.jpg";